import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { GoogleAnalytics } from '../../services/analytics';
import { ChildrenPropType } from '../../services/proptypes';
var Event = /*#__PURE__*/function (_React$Component) {
  _inherits(Event, _React$Component);
  var _super = _createSuper(Event);
  function Event() {
    _classCallCheck(this, Event);
    return _super.apply(this, arguments);
  }
  _createClass(Event, [{
    key: "formatEventType",
    value: function formatEventType() {
      var eventType = this.props.eventType;
      return "on".concat(eventType[0].toUpperCase()).concat(eventType.substring(1));
    }
  }, {
    key: "wrapEventHandler",
    value: function wrapEventHandler() {
      var _this$props = this.props,
        children = _this$props.children,
        event = _this$props.event;
      var formattedEventType = this.formatEventType();
      var childEventHandler = children.props[formattedEventType];
      return _defineProperty({}, formattedEventType, function () {
        var category = event.category,
          action = event.action,
          label = event.label,
          value = event.value,
          nonInteraction = event.nonInteraction;
        GoogleAnalytics.event(category, action, {
          label: label,
          value: value,
          nonInteraction: nonInteraction
        });
        if (childEventHandler) {
          childEventHandler();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, children.props), this.wrapEventHandler()));
    }
  }]);
  return Event;
}(React.Component);
export { Event as default };
Event.defaultProps = {};